import { useEffect } from 'react'
import { useModalBox, usePage } from '../../../../contexts'
import {
  ModalDialogBody, ModalDialogClose,
  ModalDialogContent, ModalDialogFooter,
  ModalDialogHeader, ModalDialogHeaderTitle,
  ModalDialogOverlay
} from './modal_box_styled'
import { replaceHtmlEntity } from '../../../../utils/text_replace'

const Modal = () => {
  const {
    content,
    open,
    setContent,
    setOpen,
    customModalClose,
    setCustomModalClose,
    title,
    setTitle
  } = useModalBox()
  const { baseColor } = usePage()

  const handleClose = () => {
    setOpen(false)
    setContent(null)
    setTitle(null)
    if (customModalClose) {
      customModalClose()
      setCustomModalClose(null)
    }
  }

  if (!open) return null

  useEffect(() => {
    const div = document.getElementById('dialogContent')
    if (div) {
      div.innerHTML = replaceHtmlEntity(div.innerHTML)
    }
  }, [])

  return (
    <>
      <ModalDialogOverlay onClick={handleClose} />
      <ModalDialogContent>
        <ModalDialogHeader background={baseColor}>
          {title && <ModalDialogHeaderTitle>{title}</ModalDialogHeaderTitle>}
          <ModalDialogClose onClick={handleClose}>&times;</ModalDialogClose>
        </ModalDialogHeader>

        <ModalDialogBody id="dialogContent" dangerouslySetInnerHTML={{ __html: content }} />

        <ModalDialogFooter />
      </ModalDialogContent>
    </>
  )
}

export default Modal
